module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="sets-container">\n    <div class="header-region"></div>\n    <div class="container container-with-dnd listcontrol-region" data-state="default"></div>\n    <div class="sets-list-region container"></div>\n</div>\n\n<div class="drop-control-region"></div>';
}
return __p;
};